import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../Components/ui/dialog";
import { Button } from "../Components/ui/button";
import Default_WhatsApp_background from "../Assets/Default_WhatsApp_background.jpeg";
import { FaFilePdf } from "react-icons/fa";
import RejectCampaignDialog from "./OperatorCampaignApproval/Components/RejectCampaignDialog";
import { useToast } from "../Components/ui/use-toast";
import { Toaster } from "../Components/ui/toaster";
import { CheckCircle, XCircle } from "lucide-react";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../State/store";
import { useLocation, useNavigate } from "react-router-dom";

interface TemplatePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  template: any;
  operatorUrl: string;
  templateId: number;
  templateName: string;
  accountId: number;
  workspaceId: number;
  onRefreshList: () => void;
  isApproved?: boolean;
  isRejected?: boolean;
  isCampaignPreview?: boolean;
}

const TemplatePreviewModal: React.FC<TemplatePreviewModalProps> = ({
  isOpen,
  onClose,
  template,
  operatorUrl,
  templateId,
  templateName,
  accountId,
  workspaceId,
  onRefreshList,
  isApproved = false,
  isRejected = false,
  isCampaignPreview = false,
}) => {
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const { toast } = useToast();
  const [isProcessing, setIsProcessing] = useState(false);
  const operatorId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );
  const workspaceName = useSelector(
    (state: RootState) => state.authentication.workspaceName,
  );

  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );
  if (!template) return null;

  let templateData = template;

  console.log("🔍 Raw template:", template);

  // First parse if string
  if (typeof template === "string") {
    templateData = JSON.parse(template);
  }

  console.log("🔍 After first parse:", templateData);

  // Handle nested templateContent for SMS
  if (templateData.templateContent) {
    if (typeof templateData.templateContent === "string") {
      const parsed = JSON.parse(templateData.templateContent);
      console.log("🔍 Parsed templateContent:", parsed);
      templateData = parsed.template_content || parsed;
    } else {
      templateData =
        templateData.templateContent.template_content ||
        templateData.templateContent;
    }
  }

  // Handle nested template_content
  // if (templateData.template_content) {
  //   templateData = templateData.template_content;
  // }

  console.log("🔍 Final templateData:", templateData);

  const isWhatsApp =
    templateData.template_type?.toLowerCase() === "whatsapp" ||
    (templateData.components && Array.isArray(templateData.components));

  console.log("🔍 isWhatsApp:", isWhatsApp);

  // Extract template data
// const getTemplateData = () => {
//   if (!isWhatsApp) {
//     return {
//       type: "SMS",
//       bodyText:
//         templateData.template?.message ||
//         templateData.message ||
//         templateData.body ||
//         "",
//       variableExamples:
//         templateData.template?.example?.body_text?.[0] ||
//         templateData.example?.body_text?.[0] ||
//         [],
//     };
//   }

//   const components = templateData.template.components || [];
//   const header = components.find((c: any) => c.type === "HEADER") || {};
//   const body = components.find((c: any) => c.type === "BODY") || {};
//   const footer = components.find((c: any) => c.type === "FOOTER") || {};
//   const buttonsComponent =
//     components.find((c: any) => c.type === "BUTTONS") || {};

//   const variableExamples = body?.example?.body_text?.[0] || [];

//   return {
//     type: "WhatsApp",
//     headerFormat: header.format?.toLowerCase() || "",
//     headerText: header.text || "",
//     bodyText: body.text || "",
//     footerText: footer.text || "",
//     buttons: buttonsComponent.buttons || [],
//     mediaConfig: templateData.media_config,
//     variableExamples,
//   };
// };

const getTemplateData = () => {
  if (!isWhatsApp) {
    return {
      type: "SMS",
      bodyText:
        templateData.template?.message ||
        templateData.message ||
        templateData.body ||
        "",
      variableExamples:
        templateData.template?.example?.body_text?.[0] ||
        templateData.example?.body_text?.[0] ||
        [],
    };
  }

  const components =
    templateData.template?.components ||
    templateData.components ||
    [];

  const header = components.find((c: any) => c.type === "HEADER") || {};
  const body = components.find((c: any) => c.type === "BODY") || {};
  const footer = components.find((c: any) => c.type === "FOOTER") || {};
  const buttonsComponent =
    components.find((c: any) => c.type === "BUTTONS") || {};

  const variableExamples =
    body?.example?.body_text?.[0] ||
    templateData.template?.example?.body_text?.[0] ||
    templateData.example?.body_text?.[0] ||
    [];

  return {
    type: "WhatsApp",
    headerFormat: header.format?.toLowerCase() || "",
    headerText: header.text || "",
    bodyText: body.text || "",
    footerText: footer.text || "",
    buttons: buttonsComponent.buttons || [],
    mediaConfig: templateData.media_config || templateData.template?.media_config,
    variableExamples,
  };
};


  const templateContent = getTemplateData();

  const getBase64Src = (
    base64: string,
    type: "image" | "video" | "document",
  ): string | null => {
    if (!base64) return null;
    if (base64.startsWith("data:")) return base64;

    const cleanBase64 = base64.replace(/^data:[^,]+,/, "");
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(cleanBase64)) {
      console.warn("Invalid base64 format detected");
      return null;
    }

    if (type === "image") return `data:image/jpeg;base64,${cleanBase64}`;
    if (type === "video") return `data:video/mp4;base64,${cleanBase64}`;
    if (type === "document")
      return `data:application/pdf;base64,${cleanBase64}`;
    return null;
  };

  const renderFormattedText = (text: string) =>
    text
      .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
      .replace(/_([^_]+)_/g, "<em>$1</em>")
      .replace(/~([^~]+)~/g, "<s>$1</s>")
      .replace(
        /`([^`]+)`/g,
        '<code style="background: #f1f1f1; padding: 2px 4px; border-radius: 3px;">$1</code>',
      )
      .replace(
        /\{\{(\d+)\}\}/g,
        '<span style="background: #e3f2fd; padding: 2px 4px; border-radius: 3px; color: #1976d2;">{{$1}}</span>',
      );

const renderSMSPreview = () => (
  <div className="flex flex-col w-full gap-4">
    <div className="bg-gray-50 rounded-xl p-5 overflow-y-auto min-h-[300px] max-h-[500px]">
      <div className="w-full text-left">
        <div
          className="whitespace-pre-wrap break-words text-[15px] text-gray-800 leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: renderFormattedText(templateContent.bodyText),
          }}
        />
      </div>
          {templateContent.variableExamples?.length > 0 && (
      <div className="w-full max-w-[420px] bg-white rounded-xl mt-16 shadow-sm border border-gray-200 px-4 py-3">
        {/* <p className="text-[12px] font-semibold text-gray-700 mb-2">
          Variables
        </p> */}
        <div className="space-y-1">
          {templateContent.variableExamples.map((value: string, index: number) => (
            <div key={index} className="text-[13px] text-gray-700">
              <span className="font-medium text-[#1976d2]">{`{{${index + 1}}}`}</span>{" "}
              <span>{value}</span>
            </div>
          ))}
        </div>
      </div>
    )}
    </div>


  </div>
);

  const handleApproveNotification = async (templateId: number) => {
    try {
      const payload = {
        workspaceId: operatorId || 0,
        campaignid: templateId,
        campaignname: templateName,
        statusMark: "Unread",
        notificationType: "OperatorTemplateApprove",
        notificationData: {
          Message: `${workspaceName} approved template- ${templateName}`,
        },
        role: "Admin",
      };
      debugger;

      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateNotification`,
        payload,
      );

      if (response.data.status !== "Success") {
        throw new Error("Notification API failed.");
      }
    } catch (error) {
      toast({
        title: "Notification Error",
        description: "Campaign approved but notification could not be sent.",
      });
    }
  };

  const handleRejectAndCommentNotification = async (templateId: number) => {
    try {
      const payload = {
        workspaceId: operatorId || 0,
        campaignId: templateId,
        campaignName: templateName,
        statusMark: "Unread",
        notificationType: "OperatorRejectComment",
        notificationData: {
          Message: `${workspaceName} rejected and commented on the template – ${templateName}`,
          Comment: rejectReason || "",
        },
        role: "Admin",
      };

      console.log("Combined Notification payload:", payload);

      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateNotification`,
        payload,
      );

      if (response.data.status === "Success") {
        toast({
          title: "Success",
          description: "Rejection and comment notification sent successfully.",
        });
        // setTimeout(() => {
        //   // setIsLoading(false);
        //   navigate("/operatorNavbar/templatelist");
        // }, 800);
      } else {
        throw new Error("Notification API failed.");
      }
    } catch (error) {
      console.error("Notification error:", error);
      toast({
        title: "Notification Error",
        description: "Could not send rejection and comment notification.",
      });
    }
  };

  console.log("TemplateName", templateName);

  const triggerN8NWebhook = async (
    isApproved: boolean,
    rejectComment: string = "",
  ) => {
    try {
      const payload = {
        templateID: templateId,
        templateName: templateName,
        advertiserID: accountId?.toString(),
        workspaceID: workspaceId?.toString(), // ✅ add this — from props/redux
        wrokspaceName: "",
        request_type: isApproved
          ? "operator_approval_template"
          : "operator_reject_template",
        comments: isApproved ? "Approve this Template" : rejectComment,
      };

      const response = await axios.post(
        `${operatorUrl}/N8NOperatorTemplateApprovalandRejectionWebhook`,
        payload,
      );

      if (response.status !== 200) {
        console.error("❌ Webhook Trigger Failed");
      } else {
        console.log("✅ Webhook Triggered Successfully");
      }
    } catch (error) {
      console.error("❗ Error in triggerN8NWebhook", error);
    }
  };

  
  const handleApprove = async () => {
    setIsProcessing(true);
    let afterData = {
      AccountId: accountId,
      PartnerId: workspaceId,
      status: "Approved",
    }; // Prepare afterData with updated data
    let status = "Success"; // Default status is success
    let errorMessage = ""; // Initialize error message

    try {
      const response = await axios.put(
        `${operatorUrl}/WelcomeOperatorApproval`,
        null,
        {
          params: {
            templateId: templateId,
            status: "approved",
            accountId: accountId,
            workspaceId: workspaceId,
            comment: "",
          },
        },
      );
      if (response.data.status === "Success") {
        await triggerN8NWebhook(true);
        await handleApproveNotification(templateId);
        afterData = {
          AccountId: accountId,
          PartnerId: workspaceId,
          status: "Approved",
        }; // Prepare afterData with updated data
        status = "Success"; // Default status is success
        errorMessage = "Operator Welcome Template Approval Success."; // Initialize error message
        toast({
          title: "Success",
          description: "Template approved successfully",
        });

        onClose();
        onRefreshList();
      } else {
        afterData = {
          AccountId: accountId,
          PartnerId: workspaceId,
          status: "Approved",
        }; // Prepare afterData with updated data
        status = "Failure"; // Default status is success
        errorMessage = "Operator Welcome Template Approval Failed."; // Initialize error message
        toast({
          title: "Error",
          description: response.data.message || "Approval failed.",
        });
      }
    } catch (err) {
      console.error("Approve failed", err);
      afterData = {
        AccountId: accountId,
        PartnerId: workspaceId,
        status: "Approved",
      }; // Prepare afterData with updated data
      status = "Failure"; // Default status is success
      errorMessage = "Operator Welcome Template Approval Failed."; // Initialize error message
      toast({
        title: "Error",
        description: "Failed to approve template",
        variant: "destructive",
      });
    } finally {
      const auditData = {
        UserAccountId: accountId, // Ensure userAccountId is available
        CampaignId: templateId, // If applicable, set the campaign ID
        AdvertiserWorkspaceId: workspaceId,
        Action: "Operator Welcome Template Approval",
        ActionPage: "Operator Template Preview",
        Status: status, // "Success", "Failure", or "Error"
        KeyName: null,
        KeyValue: 0,
        // Current role before update
        AfterData: JSON.stringify(afterData), // The updated role after change
        // Pass the IP address
        Comments: errorMessage, // Comment for audit log
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      await axios.post(`${apiUrlAdvAcc}/InsertOverAllAuditHistory`, auditData);

      setIsProcessing(false);
    }
  };

const renderWhatsAppPreview = () => {
  const whatsappStyle = {
    backgroundImage: `url(${Default_WhatsApp_background})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "#ECE5DD",
  };

  const mediaConfig = templateContent.mediaConfig;
  const base64 = mediaConfig?.binary_data || "";

  return (
    <div
      className="w-full rounded-xl overflow-hidden border border-gray-200"
      style={whatsappStyle}
    >
      <div className="flex flex-col items-center p-4 gap-3">
        {/* WhatsApp message card */}
        <div className="bg-white rounded-2xl shadow-md w-full max-w-[360px] overflow-hidden">
          {templateContent.headerFormat === "image" && base64 && (
            <img
              src={getBase64Src(base64, "image") || ""}
              className="w-full h-44 object-cover"
              alt="Header"
            />
          )}

          {templateContent.headerFormat === "video" && base64 && (
            <video
              controls
              className="w-full h-44 object-cover"
              src={getBase64Src(base64, "video") || ""}
            />
          )}

          <div className="px-4 pt-3 pb-2">
            {templateContent.headerFormat === "text" &&
              templateContent.headerText && (
                <p className="font-semibold text-gray-900 mb-2 text-[15px]">
                  {templateContent.headerText}
                </p>
              )}

            {templateContent.bodyText && (
              <div
                className="text-[14px] text-gray-800 leading-relaxed whitespace-pre-wrap mb-2"
                dangerouslySetInnerHTML={{
                  __html: renderFormattedText(templateContent.bodyText),
                }}
              />
            )}

            {templateContent.footerText && (
              <div className="mt-2 pt-2 border-t border-gray-200">
                <p className="text-[11px] text-gray-500 text-left">
                  {templateContent.footerText}
                </p>
              </div>
            )}
          </div>

          {templateContent.buttons?.length > 0 && (
            <div className="border-t border-gray-200">
              {templateContent.buttons.map((btn: any, idx: number) => (
                <div
                  key={idx}
                  className={`py-3 text-center text-[14px] font-medium text-[#1F7AE0]
                  ${idx < templateContent.buttons.length - 1 ? "border-b border-gray-200" : ""}`}
                >
                  {btn.text}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Variables section inside wallpaper area */}
        {templateContent.variableExamples?.length > 0 && (
          <div className="w-full max-w-[360px] bg-white/95 rounded-xl border border-gray-200 px-4 py-3">
            {/* <p className="text-[12px] font-semibold text-gray-700 mb-2">
              Variables
            </p> */}
            <div className="space-y-1">
              {templateContent.variableExamples.map((value: string, index: number) => (
                <div key={index} className="text-[13px] text-gray-700">
                  <span className="font-medium text-[#1976d2]">{`{{${index + 1}}}`}</span>{" "}
                  <span>{value}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

  const handleRejectClick = () => {
    onClose();
    setIsRejectDialogOpen(true);
  };

  return (
    <>
      {/* Main Preview Dialog */}
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="max-w-[500px] max-h-[80vh] p-0 flex flex-col">
          <DialogHeader className="px-5 pt-5 pb-3 border-b border-gray-200 shrink-0">
            <DialogTitle className="text-base font-semibold text-gray-900 flex items-center justify-between">
              {/* Left Side */}
              <span>Template Preview:</span>

              {/* Right Side Status */}
              {isApproved && (
                <div className="flex items-center mr-[230px] text-green-700 text-sm font-medium">
                  <CheckCircle className="h-4 w-4" />
                  <span>Approved</span>
                </div>
              )}

              {isRejected && (
                <div className="flex items-center mr-[230px] text-red-700 text-sm font-medium">
                  <XCircle className="h-4 w-4" />
                  <span>Rejected</span>
                </div>
              )}
            </DialogTitle>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto px-5 py-4">
            <div className="border border-gray-200 rounded-xl bg-white shadow-sm">
              {templateContent.type === "SMS"
                ? renderSMSPreview()
                : renderWhatsAppPreview()}
            </div>

            {/* Show status message if already processed */}

            {/* Show Close button if approved/rejected, otherwise show Approve/Reject buttons */}
           {!isCampaignPreview && !isApproved && !isRejected && (
  <div className="flex gap-3 mt-5">
    <Button
      variant="outline"
      onClick={handleRejectClick}
      disabled={isProcessing}
      className="flex-1 h-11 px-6 border-2 border-red-500 text-red-500 hover:bg-red-50 hover:text-red-600 font-medium rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isProcessing ? "Processing..." : "Reject"}
    </Button>
    <Button
      onClick={handleApprove}
      disabled={isProcessing}
      className="flex-1 h-11 px-6 text-white bg-[#3A85F7] font-medium rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isProcessing ? "Processing..." : "Approve"}
    </Button>
  </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Reject Comment Dialog */}
      <RejectCampaignDialog
        open={isRejectDialogOpen}
        comment={rejectReason}
        setComment={setRejectReason}
        onClose={() => {
          setIsRejectDialogOpen(false);
          // setRejectReason("");
        }}
        onConfirm={async (comment) => {
          setIsProcessing(true);
          let afterData = {
            AccountId: accountId,
            PartnerId: workspaceId,
            status: "Rejected",
            comment: comment
          }; // Prepare afterData with updated data
          let status = "Success"; // Default status is success
          let errorMessage = ""; // Initialize error message

          try {
            const response = await axios.put(
              `${operatorUrl}/WelcomeOperatorApproval`,
              null,
              {
                params: {
                  templateId: templateId,
                  status: "rejected",
                  accountId: accountId,
                  workspaceId: workspaceId,
                  comment: comment,
                },
              },
            );
            if (response.data.status === "Success") {
              await triggerN8NWebhook(false, comment);
              await handleRejectAndCommentNotification(templateId);

              toast({
                title: "Success",
                description: "Template rejected successfully",
              });

              afterData = {
                AccountId: accountId,
                PartnerId: workspaceId,
                status: "Rejected",
                comment: comment
              }; // Prepare afterData with updated data
              status = "Success"; // Default status is success
              errorMessage = "Operator Welcome Template Approval Success."; // Initialize error message
              toast({
                title: "Success",
                description: "Template rejected successfully",
              });

              setIsRejectDialogOpen(false);
              setRejectReason("");

              setTimeout(() => {
                onClose();
                onRefreshList();
              }, 300);
            } else {
              afterData = {
                AccountId: accountId,
                PartnerId: workspaceId,
                status: "Rejected",
                comment:comment
              }; // Prepare afterData with updated data
              status = "Failure"; // Default status is success
              errorMessage = "Operator Welcome Template Approval Failed."; // Initialize error message
              toast({
                title: "Error",
                description: response.data.message || "Approval failed.",
              });
            }
          } catch (err) {
            console.error("Reject failed", err);
            afterData = {
              AccountId: accountId,
              PartnerId: workspaceId,
              status: "Rejected",
              comment:comment
            }; // Prepare afterData with updated data
            status = "Failure"; // Default status is success
            errorMessage = "Operator Welcome Template Approval Failed."; // Initialize error message
            toast({
              title: "Error",
              description: "Failed to reject template",
              variant: "destructive",
            });
          } finally {
            const auditData = {
              UserAccountId: accountId, // Ensure userAccountId is available
              CampaignId: templateId, // If applicable, set the campaign ID
              AdvertiserWorkspaceId: workspaceId,
              Action: "Operator Welcome Template Approval",
              ActionPage: "Operator Template Preview",
              Status: status, // "Success", "Failure", or "Error"
              KeyName: null,
              KeyValue: 0,
              // Current role before update
              AfterData: JSON.stringify(afterData), // The updated role after change
              // Pass the IP address
              Comments: errorMessage, // Comment for audit log
              ImpersonatorUserAccountId: isImpersonated
                ? impersonatorAID
                : null,
            };

            await axios.post(
              `${apiUrlAdvAcc}/InsertOverAllAuditHistory`,
              auditData,
            );
            setIsProcessing(false);
          }
        }}
      />
    </>
  );
};

export default TemplatePreviewModal;
